import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';

import { cardStyles as styles } from './index';

const SoldAssetsStatusReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sold-assets-status-report',
      params: { 'sale-id': saleId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sold Assets Status Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>{sale.name}</option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default SoldAssetsStatusReport;
